namespace GeniuzPOS.PosShift {
    export interface VatRefundData extends Serenity.ListRequest {
        Header?: PsVatRefundRow;
        ConfigPrintFg?: number;
        ConfigPrint?: PsVatRefundPrintingParaRow;
        Details?: PsVatRefundDtRow[];
        ToPage?: number;
        AllPage?: number;
        DocNo?: string;
        sumfristpage?: number;
        sumtopage?: number;
        Addressno?: string;
        Street?: string;
        District?: string;
        Province?: string;
        TelNo?: string;
        buyCountry?: string;
        BizName?: string;
        ShopName?: string;
        ShopAddress?: string;
        ShopTaxId?: string;
        BranchName?: string;
    }
}
